module.exports = __webpack_public_path__ + "@/assets/img/cotizador.8cff7d00.png";